import type { RequestPayload } from "@inertiajs/core";
import { router } from "@inertiajs/react";
import { CertificateReportForm } from "../../../components/report/form/CertificateReportForm";
import { useYearContext } from "../../../hooks/useYearContext";
import { ContentShell } from "../../../layout/ContentShell";
import type { Coach } from "../../../models/coach";
import type { CertificateReport } from "../../../models/reports/certificateReport";
import { report_path, reports_path } from "../../../routes";

type CertificateReportEditProps = {
  certificate_report: CertificateReport;
  coaches: Coach[];
};

export default function CertificateReportEdit({ certificate_report, coaches }: CertificateReportEditProps) {
  const { pathWithYearContext } = useYearContext();
  const onSubmit = (values: RequestPayload) => router.patch(pathWithYearContext(report_path, certificate_report.id), values);
  return (
    <ContentShell title={`Bericht ${certificate_report.title}`} onBack={() => router.get(pathWithYearContext(reports_path))}>
      <CertificateReportForm onSubmit={onSubmit} certificateReport={certificate_report} saveButtonLabel="Speichern" coaches={coaches} />
    </ContentShell>
  );
}
